import React, { useCallback, useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Alert, Button, message, Result, Tag, Typography } from "antd";

import "./customHtml.scss";
import { custom_html } from "../../apis/paymentGateway";
import { replaceUrlByParams } from "../../utils/api";
import { PAGE } from "../../utils/constants";
import { AppContext } from "../../App";

function CustomHTMLPage() {
  let history = useHistory();
  const { pid } = useParams();
  const { appSetting, loading, setLoading } = useContext(AppContext);
  const { Text } = Typography;

  const [customHtml, setCustomHtml] = useState(null);

  const getCustomHTMLInfo = useCallback(async () => {
    setLoading(true);
    try {
      const res = await custom_html();
      console.log(res);
      if (res.error) {
        message.error("操作無效，重新定向", 1, () => history.goBack());
        throw new Error(`${res.error.msgCode} - ${res.error.message}`);
      } else {
        setCustomHtml(res);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  }, [history, setLoading]);

  useEffect(() => {
    getCustomHTMLInfo();
  }, [getCustomHTMLInfo]);

  return (
    <>
      {customHtml && (
        <Result
          className="custom-html"
          title="其他付款方式"
          extra={
            <>
              <div
                dangerouslySetInnerHTML={{
                  __html: customHtml.custom.html,
                }}
              ></div>
              <Button
                type="primary"
                style={{ marginBottom: "16px" }}
                onClick={() => {
                  history.push(
                    `${replaceUrlByParams(PAGE.APPLICATION_RESULT, {
                      ":pid": pid,
                    })}`
                  );
                }}
              >
                完成付款並返回
              </Button>
            </>
          }
        >
          <Text>
            *閣下可隨時於課程主頁<Tag>{appSetting.checkResultButton}</Tag>
            <span>以</span>
            {appSetting.checkResultForm.map((field, i) => {
              return <Tag key={i}>{field.name}</Tag>;
            })}
            登入付款
          </Text>
          <div style={{ marginTop: "16px" }}>
            <Alert
              message="繳費狀態更新需要數個工作天。請留意你是否已繳費，以免重覆付款。如有問題請聯絡我們"
              type="error"
            />
          </div>
        </Result>
      )}
    </>
  );
}

export default CustomHTMLPage;
